import React, { Component } from 'react';
import PropTypes from "prop-types";
import { CONSTANTS } from 'services/constants';

class Separator extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const {
            image
        } = this.props;

        return (
            <div className="h-half tw-bg-cover tw-bg-center tw-flex tw-items-end tw-flex-wrap tw-text-center tw-justify-center" style={{ backgroundImage: "url(" + image + ")", }} />
        );
    }
}

Separator.defaultProps = {
    image: CONSTANTS.UI.DEFAULT_IMAGE_SEPARATOR,
};

Separator.propTypes = {
    image: PropTypes.node.isRequired,
};

export default Separator;
